import React from "react";
import { ArrowLeft, Bell, BellOff, ScanLine, Download, LogOut, CalendarX } from "lucide-react";

const LOGO_URL = "https://customer-assets.emergentagent.com/job_6e85a7b3-7844-4782-8600-31defd3a9a43/artifacts/5fhyey8q_MV%20trasporti%20logo.png";

export function DriverHeader({ showBack, title, driverInfo, goBack, navigateTo, togglePush, pushEnabled, setShowScanner, installPrompt, setInstallPrompt, logout }) {
  return (
    <div className="bg-[#09090B] text-white px-4 py-3 flex items-center justify-between sticky top-0 z-50">
      <div className="flex items-center gap-3">
        {showBack ? (
          <button onClick={() => goBack()} className="p-1 text-zinc-400 hover:text-white" data-testid="back-btn"><ArrowLeft size={22} /></button>
        ) : (
          <img src={LOGO_URL} alt="MV" className="h-8" style={{ filter: "invert(1)" }} />
        )}
        <div>
          <p className="text-sm font-bold">{title || driverInfo.name}</p>
          <p className="text-[10px] text-zinc-500 font-mono">{driverInfo.plate}</p>
        </div>
      </div>
      <div className="flex items-center gap-1">
        <button onClick={() => navigateTo("absences")} className="p-2 text-zinc-400 hover:text-[#FF5200]" data-testid="nav-assenze-header">
          <CalendarX size={18} />
        </button>
        <button onClick={togglePush} className={`p-2 ${pushEnabled ? "text-[#FF5200]" : "text-zinc-400"}`} data-testid="toggle-push-btn">
          {pushEnabled ? <Bell size={18} /> : <BellOff size={18} />}
        </button>
        <button onClick={() => setShowScanner(true)} className="p-2 text-zinc-400" data-testid="open-scanner-btn"><ScanLine size={20} /></button>
        {installPrompt && <button onClick={() => { installPrompt.prompt(); setInstallPrompt(null); }} className="px-2 py-1 bg-[#FF5200] text-white text-[10px] font-bold uppercase rounded-sm" data-testid="install-app-btn"><Download size={12} /></button>}
        <button onClick={logout} className="p-2 text-zinc-400" data-testid="driver-logout-btn"><LogOut size={18} /></button>
      </div>
    </div>
  );
}
